function mobidevFancyboxOpen(target, options) {
    var open = function () {
        $.fancybox.open(target, options);
    };
    if ($.fancybox && $.fancybox.open) {
        open();
        return;
    }
    if (window.mobidevOnFancyboxReady) {
        window.mobidevOnFancyboxReady(open);
        return;
    }
    window.addEventListener('lib:fancybox-ready', open, { once: true });
}

function mobidevFancyboxClose() {
    if ($.fancybox && $.fancybox.close) {
        $.fancybox.close();
    }
}
if ( $('body').is('.page-template-contact_page') || $('#formDropzone').length) {
    Dropzone.autoDiscover = false;
    var formDropzone = new Dropzone("#formDropzone", {
        url: ajaxurl + '?action=send_form',
        paramName: 'form_file',
        parallelUploads: 5,
        filesizeBase: 1024,
        //maxFiles: 5,
        maxFilesize: 25,
        timeout: 180000,
        uploadMultiple: true,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: input_form_button,
        dictFileTooBig: input_form_size_error,
        dictMaxFilesExceeded: input_form_count_error,
        acceptedFiles: '.jpeg,.jpg,.png,.gif,.bmp,.txt,.pdf,.csv,.rtf,.ppt,.pptx,.odp,.odt,.ods,.xls,.xlsx,.doc,.docx',
        accept: function(file, done) {
            const acceptedFiles = ['jpeg','jpg','png','gif','bmp','txt','pdf','csv','rtf','ppt','pptx','odp','odt','ods','xls','xlsx','doc','docx'];
            let fileName = file.name;
            let fileExtension = fileName.split('.').pop();
            if (file.size === 0) {
                done("Sorry, Your file is empty, Nothing to upload.");
                return;
            } else if($.inArray(fileExtension.toLowerCase(), acceptedFiles) === -1) {
                done("Sorry, You can't upload this file.");
                return;
            } else {
                done();
            }
        },
        //Called just before each file is sent
        sending: function(file, xhr, formData) {
            //Execute on case of timeout only
            xhr.ontimeout = function (e) {
                //Output timeout error message here
                console.log('Server Timeout');
            };
        },
        init: function () {
            let form = '#contact_1';
            var myDropzone = this;

            myDropzone.on("addedfiles", function(files) {
                const dropzoneFilesList = myDropzone.files;
                const maxFilesCount = 5;
                const maxFileSize = 26214400;

                if (dropzoneFilesList.length > maxFilesCount && files.length > maxFilesCount) {
                    alert(input_form_count_error);
                    myDropzone.removeAllFiles();
                    return;
                }

                if (dropzoneFilesList.length > maxFilesCount && files.length <= maxFilesCount) {
                    alert(input_form_count_error);
                    for (let i = dropzoneFilesList.length - files.length; i < dropzoneFilesList.length; i++) {
                        myDropzone.removeFile(dropzoneFilesList[i]);
                    }
                    return;
                }

                for (let i = 0; i < dropzoneFilesList.length; i++) {
                    if (dropzoneFilesList[i].size > maxFileSize) {
                        alert(input_form_size_error);
                        myDropzone.removeFile(dropzoneFilesList[i]);
                    }
                }

                for (let i = 0; i < dropzoneFilesList.length; i++) {
                    if (!dropzoneFilesList[i].accepted) {
                        alert(input_form_type_error);
                        myDropzone.removeFile(dropzoneFilesList[i]);
                    }
                }
            });

            var btn = $(".btn.for-dropzone");
            btn.click(function () {
                $(form).validate();

                if($(form).valid()) {
                    if (myDropzone.getQueuedFiles().length > 0) {
                        // Disabling submit button
                        let btn = $(".btn.for-dropzone");
                        btn.attr("disabled", "disabled");
                        btn.val('Processing...');

                        // Open loading modal
                        $("#loadMe").modal({
                            backdrop: "static", //remove ability to close modal with click
                            keyboard: false, //remove option to close with keyboard
                            show: true //Display loader!
                        });
                        if (typeof recaptcha_key != 'undefined') {
                            grecaptcha.ready(function() {
                                grecaptcha.execute(recaptcha_key, {action: 'contact_page'}).then(function (token) {
                                    $.ajax({
                                        type: "POST",
                                        url: "/wp-admin/admin-ajax.php?action=verifyReCaptcha",
                                        dataType: "JSON",
                                        data: {
                                            'token': token,
                                            'captcha_action': $(form + ' ' + '#action').val(),
                                            'email': $(form + ' ' + '#your-email').val()
                                        },
                                        success: function (response) {
                                            if(response && response.success === false) {
                                                if(response.data) {
                                                    alert(response.data);
                                                    window.location.reload();
                                                } else {
                                                    window.location.reload();
                                                }
                                            } else {
                                                myDropzone.processQueue();
                                            }
                                        }
                                    });
                                });
                            });
                        } else {
                            myDropzone.processQueue();
                        }
                    }
                }
            });

            myDropzone.on('sending', function (file, xhr, formData) {
                const nameField = $(form + ' ' + '#your-name').val();
                if(nameField.indexOf(',') !== -1) {
                    const result = nameField.split(',');

                    formData.append('name', $.trim(result[0]));
                    formData.append('company', $.trim(result[1]));
                } else {
                    formData.append('name', $.trim(nameField));
                }

                let email = $(form + ' ' + '#your-email').val();
                formData.append('email', $.trim(email.toLowerCase()));

                const phoneField = $(form + ' ' + '#your-phone').val();
                if(phoneField.indexOf('/') !== -1) {
                    const res = phoneField.split('/');

                    const phone = res[0];
                    const skype = res[1];

                    formData.append('phone', $.trim(phone.replace(/[^0-9+]/g, '')));
                    formData.append('skype', $.trim(skype));
                } else if(!/^(\+?)?[0-9\-()\s+]+$/i.test(phoneField)) {
                    formData.append('skype', phoneField);
                    formData.delete('phone');
                } else {
                    formData.append('phone', $.trim(phoneField.replace(/[^0-9+]/g, '')));
                }

                formData.append('location', $(form + ' ' + 'select[name="location"]').val());

                formData.append('description', $(form + ' ' + '#your-description').val());

                if($(form + ' ' + '#subscribeCheck').is(":checked")) {
                    formData.append('subscribe_company', 'on');
                }

                formData.append('token', $(form + ' ' + 'input[name="token"]').val());
                formData.append('notification', $(form + ' ' + 'input[name="notification"]').val());
                formData.append('form_title', 'The Website Contact Form');
                formData.append('refererURL', localStorage.getItem("ext-referrer") ? localStorage.getItem("ext-referrer") : document.referrer);
                formData.append('own_clientID', $(form + ' ' + 'input[name="own_clientID"]').val());
                formData.delete('action');
            });

            myDropzone.on('successmultiple', function (file, response) {
                $(".btn.for-dropzone").val('Done');
                $("#loadMe").modal("hide");
                if(response && response.success === false) {
                    alert('Error occurred');
                    window.location.href = "/";
                } else {
                    if ($(form).hasClass('notification_type_3')) {
                        $('.btn-new.for-dropzone').val('Successfully sent');

                        mobidevFancyboxOpen($('#contact_1 .successful'), {
                            'beforeShow': function () {
                                $('#contact_1 .successful').addClass('contact-form-fancy');
                            },
                            'afterClose': function () {
                                myDropzone.removeAllFiles();
                                $('form#contact_1').trigger("reset");
                                $(".btn-new.for-dropzone").val('Send Request');
                                $(".btn-new.for-dropzone").prop("disabled", false);
                            }
                        });
                    }
                }
            });

            myDropzone.on("errormultiple", function(files, response) {
                // event when there's an error
                if(response && response.success === false) {
                    alert(response.data);
                    window.location.reload();
                }
            });
        }
    });
}

if ( $('body').is('.page-template-template-internership, .page-template-template-application-form, .single-vacancy')) {
    Dropzone.autoDiscover = false;
    var careerDropzone = new Dropzone("#careerDropzone", {
        url: ajaxurl + '?action=send_form',
        paramName: 'form_file',
        parallelUploads: 2,
        filesizeBase: 1024,
        //maxFiles: 2,
        maxFilesize: 25,
        timeout: 180000,
        uploadMultiple: true,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: dropzone_career,
        dictFileTooBig: career_size_error,
        dictMaxFilesExceeded: career_count_error,
        acceptedFiles: '.jpeg,.jpg,.png,.gif,.bmp,.txt,.pdf,.csv,.rtf,.ppt,.pptx,.odp,.odt,.ods,.xls,.xlsx,.doc,.docx',
        accept: function(file, done) {
            const acceptedFiles = ['jpeg','jpg','png','gif','bmp','txt','pdf','csv','rtf','ppt','pptx','odp','odt','ods','xls','xlsx','doc','docx'];
            let fileName = file.name;
            let fileExtension = fileName.split('.').pop();
            if (file.size === 0) {
                done("Sorry, Your file is empty, Nothing to upload.");
                return;
            } else if($.inArray(fileExtension.toLowerCase(), acceptedFiles) === -1) {
                done("Sorry, You can't upload this file.");
                return;
            } else {
                done();
            }
        },
        //Called just before each file is sent
        sending: function(file, xhr, formData) {
            //Execute on case of timeout only
            xhr.ontimeout = function (e) {
                //Output timeout error message here
                console.log('Server Timeout');
            };
        },
        init: function () {
            let form = '#career';
            var myDropzone = this;
            const maxFilesCount = 2;
            const maxFileSize = 26214400;
            const dropzoneDesktopMainText = document.querySelector(".vacancy__form-dropzone-text");
            const dropzoneDesktopLoadText = document.querySelector(".vacancy__form-dropzone-load-text");
            const dropzoneTabletMainText = document.querySelector(".vacancy__form-dropzone-tablet-title");
            const dropzoneTabletAddText = document.querySelector(".vacancy__form-dropzone-tablet-title-add");
            const dropzoneTabletIcon = document.querySelector(".vacancy__form-dropzone-text-icon");
            const dropzoneTabletIconDisabled = document.querySelector(".vacancy__form-dropzone-text-icon-disabled");
            const dropzoneMobileBottomText = document.querySelector(".vacancy__dropzone-mobile-bottom-text");
            const dropzoneCareerCheckbox = document.querySelector(".career-checkbox");

            myDropzone.on("addedfiles", function(files) {
                const dropzoneFilesList = myDropzone.files;
                if (dropzoneFilesList.length >= maxFilesCount) {
                    if (dropzoneDesktopMainText) {
                        dropzoneDesktopMainText.style.color = "#C1C4CA";
                        dropzoneDesktopLoadText.style.color = "#C1C4CA";
                    }
                    if (dropzoneTabletMainText) {
                        dropzoneTabletMainText.style.color = "#C1C4CA";
                        dropzoneTabletAddText.style.color = "#C1C4CA";
                        dropzoneMobileBottomText.style.display = "none";
                        if (window.innerWidth <= 640) {
                            dropzoneCareerCheckbox.style.bottom = "-200px";
                        }
                    }
                    dropzoneTabletIcon.style.display = "none";
                    dropzoneTabletIconDisabled.style.display = "block";
                }

                if (dropzoneFilesList.length > maxFilesCount && files.length > maxFilesCount) {
                    alert(career_count_error);
                    myDropzone.removeAllFiles();
                    return;
                }

                if (dropzoneFilesList.length > maxFilesCount && files.length <= maxFilesCount) {
                    alert(career_count_error);
                    for (let i = dropzoneFilesList.length - files.length; i < dropzoneFilesList.length; i++) {
                        myDropzone.removeFile(dropzoneFilesList[i]);
                    }
                    return;
                }

                for (let i = 0; i < dropzoneFilesList.length; i++) {
                    if (dropzoneFilesList[i].size > maxFileSize) {
                        alert(career_size_error);
                        myDropzone.removeFile(dropzoneFilesList[i]);
                    }
                }

                for (let i = 0; i < dropzoneFilesList.length; i++) {
                    if (!dropzoneFilesList[i].accepted) {
                        alert(career_type_error);
                        myDropzone.removeFile(dropzoneFilesList[i]);
                    }
                }
            });

            myDropzone.on("removedfile", function(files) {
                const dropzoneFilesList = myDropzone.files;

                if (dropzoneFilesList.length < maxFilesCount) {
                    if (dropzoneDesktopMainText) {
                        dropzoneDesktopMainText.style.color = null;
                        dropzoneDesktopLoadText.style.color = null;
                    }
                    if (dropzoneTabletMainText) {
                        dropzoneTabletMainText.style.color = null;
                        dropzoneTabletAddText.style.color = null;
                        dropzoneMobileBottomText.style.display = null;
                        dropzoneCareerCheckbox.style.bottom = null;
                    }
                    dropzoneTabletIcon.style.display = null;
                    dropzoneTabletIconDisabled.style.display = null;
                    return;
                }
            });

            var btn = $(".btn.for-dropzone");
            btn.click(function () {
                $(form).validate();

                if($(form).valid()) {
                    if (myDropzone.getQueuedFiles().length > 0) {
                        // Disabling submit button
                        let btn = $(".btn.for-dropzone");
                        btn.attr("disabled", "disabled");
                        btn.val('Processing...');

                        if (typeof recaptcha_key != 'undefined') {
                            grecaptcha.ready(function() {
                                grecaptcha.execute(recaptcha_key, {action: 'career_page'}).then(function (token) {
                                    $.ajax({
                                        type: "POST",
                                        url: "/wp-admin/admin-ajax.php?action=verifyReCaptcha",
                                        dataType: "JSON",
                                        data: {
                                            'token': token,
                                            'captcha_action': $(form + ' ' + '#action').val(),
                                            'email': $(form + ' ' + '#career-email').val()
                                        },
                                        success: function (response) {
                                            if(response && response.success === false) {
                                                if(response.data) {
                                                    alert(response.data);
                                                    window.location.reload();
                                                } else {
                                                    window.location.reload();
                                                }
                                            } else {
                                                myDropzone.processQueue();
                                            }
                                        }
                                    });
                                });
                            });
                        } else {
                            myDropzone.processQueue();
                        }
                    }
                }
            });

            myDropzone.on('sending', function (file, xhr, formData) {
                const firstNameField = $(form + ' ' + '#career-first-name').val();
                const lastNameField = $(form + ' ' + '#career-last-name').val();

                formData.append('career_first_name', $.trim(firstNameField));
                formData.append('career_last_name', $.trim(lastNameField));

                const careerPosition = $(form + ' ' + '#career-position').val();
                formData.append('career-position', $.trim(careerPosition));

                let email = $(form + ' ' + '#career-email').val();
                formData.append('email', $.trim(email.toLowerCase()));

                const phoneField = $(form + ' ' + '#career-phone').val();
                if(phoneField.indexOf('/') !== -1) {
                    const res = phoneField.split('/');

                    const phone = res[0];
                    const skype = res[1];

                    formData.append('phone', $.trim(phone.replace(/[^0-9+]/g, '')));
                    formData.append('skype', $.trim(skype));
                } else if(!/^(\+?)?[0-9\-()\s+]+$/i.test(phoneField)) {
                    formData.append('skype', phoneField);
                    formData.delete('phone');
                } else {
                    formData.append('phone', $.trim(phoneField.replace(/[^0-9+]/g, '')));
                }

                formData.append('city', $(form + ' ' + '#career-city').val());
                formData.append('source', $(form + ' ' + '#career-source').val());
                formData.append('description', $(form + ' ' + '#career-comment').val().replace(/[^\p{L}\p{N}\p{P}\p{Z}{\^\$}]/gu, ''));

                if($(form + ' ' + '#subscribeCheck').is(":checked")) {
                    formData.append('subscribe_company', 'on');
                }

                formData.append('token', $(form + ' ' + 'input[name="token"]').val());
                formData.append('notification', $(form + ' ' + 'input[name="notification"]').val());
                formData.append('vacancy-form-type', $(form + ' ' + 'input[name="vacancy-form-type"]').val());
                formData.append('vacancy-id', $(form + ' ' + 'input[name="vacancy-id"]').val());
                formData.append('vacancy-title', $(form + ' ' + 'input[name="vacancy-title"]').val());
                formData.append('zoho-job-id', $(form + ' ' + 'input[name="zoho-job-id"]').val());
                formData.append('form_title', 'Career Form');
                formData.append('refererURL', localStorage.getItem("ext-referrer") ? localStorage.getItem("ext-referrer") : document.referrer);
                formData.delete('action');                mobidevFancyboxClose();
            });

            myDropzone.on('successmultiple', function (file, response) {
                $(".btn.for-dropzone").val('Done');

                // Open modal
                $("#loadMe").modal({
                    backdrop: "static", //remove ability to close modal with click
                    keyboard: false, //remove option to close with keyboard
                    show: true //Display loader!
                })

                mobidevFancyboxClose();
                if(response && response.success === false) {
                    $("#loadMe").modal("hide");
                    alert('Error occurred');
                    window.location.href = "/";
                } else {
                    if ($(form).hasClass('notification_type_3')) {
                        $("#loadMe").modal("hide");
                        window.location.href = form_redirect;
                    } else if ($(form).hasClass('notification_type_4')) {
                        $('.contact-page-loader').fadeOut();
                        $(".btn.for-dropzone").val('Done');
                        $('.success').fadeIn();
                        $('#career').trigger("reset");
                        myDropzone.removeAllFiles();

                        setTimeout(function () {
                            $(".btn.for-dropzone").val('Submit Application');
                            $(".btn.for-dropzone").prop("disabled", false);
                            $('#loadMe').modal('hide');
                            $('.contact-page-loader').fadeIn();
                            $('.success').fadeOut();
                        }, 10000);
                    }
                }
            });

            myDropzone.on("errormultiple", function(files, response) {
                // event when there's an error
                if(response && response.success === false) {
                    alert(response.data);
                    window.location.reload();
                }
            });
        }
    });
}
